import {isAnyOf} from '@reduxjs/toolkit'

import {initPurchaseConfirmation, initPurchaseConfirmationResult} from '@web/actions/purchaseConfirmation'
import {APIStatus, OrderPhase} from '@web/core/constants'
import {decodeUrl, examineUrlSafety, getQuery} from '@web/helpers/path'
import makeSlice from '@web/slices/common/sliceMaker'

const commonSlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(
                initPurchaseConfirmation.fulfilled,
                (
                    state,
                    {
                        payload: {
                            data: {orderNo},
                            backUrl,
                        },
                    },
                ) => {
                    state.seqID = orderNo
                    state.backUrl = examineUrlSafety(backUrl, '') || null
                },
            )
            .addCase(initPurchaseConfirmationResult.fulfilled, (state, {payload: {orderNo, backUrl, data}}) => {
                state.seqID = orderNo
                state.backUrl = examineUrlSafety(backUrl, '') || null
                state.entry = data.confirmedProductOrders[0]?.saleChannelType ?? 'ETC'
                state.orderPhase = OrderPhase.RESULT
            })
            .addMatcher(isAnyOf(initPurchaseConfirmation.pending, initPurchaseConfirmationResult.pending), (state) => {
                state.scene = APIStatus.FETCHING
            })
            .addMatcher(
                isAnyOf(initPurchaseConfirmation.fulfilled, initPurchaseConfirmationResult.fulfilled),
                (state) => {
                    state.scene = APIStatus.RESOLVED
                },
            )
            .addMatcher(
                isAnyOf(initPurchaseConfirmation.rejected, initPurchaseConfirmationResult.rejected),
                (state) => {
                    state.scene = APIStatus.REJECTED
                },
            )
            .addMatcher(
                isAnyOf(initPurchaseConfirmation.rejected, initPurchaseConfirmationResult.rejected),
                (state) => {
                    const {backUrl} = getQuery<{backUrl?: string}>()
                    if (backUrl) {
                        state.backUrl = examineUrlSafety(decodeUrl(backUrl), '') || null
                    } else {
                        state.backUrl = null
                    }
                },
            )
    },
})

export default commonSlice.reducer
